import { lazy } from 'react';

// project imports
import GuestGuard from 'utils/route-guard/GuestGuard';
import MinimalLayout from 'layout/MinimalLayout';
import NavMotion from 'layout/NavMotion';
import Loadable from 'ui-component/Loadable';

// login routing
const AuthLogin = Loadable(lazy(() => import('views/pages/authentication/authentication1/Login1')));
const AuthPIMCLogin = Loadable(lazy(() => import('views/pages/authentication/authentication1/PIMCLogin')));
const AuthLoginEntrar = Loadable(lazy(() => import('views/pages/authentication/authentication1/Login1Entrar')));
const AuthRegister = Loadable(lazy(() => import('views/pages/authentication/authentication3/Register3')));
const AuthForgotPassword = Loadable(lazy(() => import('views/pages/authentication/authentication3/ForgotPassword3')));
const AuthAdmitionRegister = Loadable(lazy(() => import('views/admissionregister/AdmitionRegisterForm')));
const AuthAdmitionRegisterEntrar = Loadable(lazy(() => import('views/admissionregister/AdmissionRegistrationFormEntrar')));
const AuthDistanceAdmitionRegister = Loadable(lazy(() => import('views/distanceeducationadmission/DistanceEducationForm')));
const AuthPIMCRegister = Loadable(lazy(() => import('views/pimc/PIMCRegistrationPage')));
const OTPPage = Loadable(lazy(() => import('../views/pages/authentication/authentication1/OTP')));
const AdmissionGuidelines = Loadable(lazy(() => import('../views/admissionregister/AdmissionGuidelines')));
const RegistrationProfile = Loadable(lazy(() => import('views/profile/RegistrationProfile')));
const HallTicketProfile = Loadable(lazy(() => import('views/profile/HallTicketProfile')));
const DraftPayslipData = Loadable(lazy(() => import('views/profile/QrDraftPayslip')));
const AdmissionProfile = Loadable(lazy(() => import('views/profile/AdmissionProfile')));
const RegistrationReceipt = Loadable(lazy(() => import('views/profile/RegistrationReceipt')));
const RegistrationFeeReceipt = Loadable(lazy(() => import('views/profile/AdmissionFeeReceipt')));
const StudentAcedemicAdmission = Loadable(lazy(() => import('views/profile/StudentAcedemicAdmisson')));
const ChangeUserPassword = Loadable(lazy(() => import('views/pages/authentication/authentication1/ResetPassword1')));
const ComapnyRgistration = Loadable(lazy(() => import('views/companyregistration/ComapnyRegistration')));
const ComapnyOTPVerification = Loadable(lazy(() => import('views/companyregistration/CompanyOTPVarification')));
const JobPostTeachers = Loadable(lazy(() => import('views/application/teachershiringunauth/TeachingJobPosting')));
const AppointmentAdd = Loadable(lazy(() => import('views/paDashboard/AddAppointment')));
const AppointmentAddWebView = Loadable(lazy(() => import('views/paDashboard/WebViewAppointment')));
const StudentSemestersSummary = Loadable(lazy(() => import('views/profile/StudentSemestersSummary')));
// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
    path: '/',
    element: (
        <NavMotion>
            <GuestGuard>
                <MinimalLayout />
            </GuestGuard>
        </NavMotion>
    ),
    children: [
        {
            path: '/login',
            element: <AuthLogin />
        },
        {
            path: '/appointment',
            element: <AppointmentAdd />
        },
        {
            path: '/webview/appointment/:id',
            element: <AppointmentAddWebView />
        },
        {
            path: '/register',
            element: <AuthRegister />
        },
        {
            path: '/admission/:id',
            element: <AuthAdmitionRegister />
        },
        {
            path: '/distance/admission/:id',
            element: <AuthDistanceAdmitionRegister />
        },
        // {
        //     path: '/pimc/admission/:id',
        //     element: <AuthPIMCRegister />
        // },
        {
            path: '/forgot',
            element: <AuthForgotPassword />
        },
        {
            path: '/otp/page',
            element: <OTPPage />
        },
        {
            path: '/admission/guidelines',
            element: <AdmissionGuidelines />
        },
        {
            path: '/registration/profile/:id',
            element: <RegistrationProfile />
        },
        {
            path: '/hallticket/:id',
            element: <HallTicketProfile />
        },
        {
            path: '/draft/payslip/:id',
            element: <DraftPayslipData />
        },
        {
            path: '/admission/profile/:id',
            element: <AdmissionProfile />
        },
        {
            path: '/registration/receipt/:userId/:FeeCodeId',
            element: <RegistrationReceipt />
        },
        {
            path: '/admission/fee/receipt/:receiptId',
            element: <RegistrationFeeReceipt />
        },
        {
            path: '/student/acedemicadmission/:receiptId',
            element: <StudentAcedemicAdmission />
        },
        {
            path: '/ustmentrar/password/change/:tokens',
            element: <ChangeUserPassword />
        },
        {
            path: '/company/registration/:id',
            element: <ComapnyRgistration />
        },
        {
            path: '/company/otp/varification',
            element: <ComapnyOTPVerification />
        },
        {
            path: '/job/post/teachers/:id',
            element: <JobPostTeachers />
        },
        {
            path: '/semesters/summary/:id',
            element: <StudentSemestersSummary />
        }
    ]
};

export default LoginRoutes;
